import { render, staticRenderFns } from "./TabelaDePrecos.vue?vue&type=template&id=457c9d51"
import script from "./TabelaDePrecos.vue?vue&type=script&lang=js"
export * from "./TabelaDePrecos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports